import { render, staticRenderFns } from "./VoteItem.vue?vue&type=template&id=c180397c&scoped=true&"
import script from "./VoteItem.vue?vue&type=script&lang=js&"
export * from "./VoteItem.vue?vue&type=script&lang=js&"
import style0 from "./VoteItem.vue?vue&type=style&index=0&id=c180397c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c180397c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
